import api from '~/api'

const state = {
  categories: [],
}

const getters = {
  categories: s => s.categories,
}

const mutations = {
  SET_CATEGORIES(state, payload) {
    state.categories = payload
  },
}

const actions = {
  async getCategories({ commit }) {
    const [, result] = await api.get('/categories')

    if (!result) return

    commit('SET_CATEGORIES', result.items)

    return result.items
  },
  getCategory(ctx, id) {
    return api.get(`/categories/${id}`)
  },

  createCategory(ctx, payload) {
    return api.post('/categories', payload)
  },

  updateCategory(ctx, payload) {
    return api.put(`/categories/${payload.id}`, payload)
  },

  deleteCategory(ctx, id) {
    return api.delete(`/categories/${id}`)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
